import { useQuery } from "react-query";
import { getAttributesForReferences } from "components/attributes/lib/attribute-data";

export const useAttributesForReferences = (codingWipKey, activeProductKeys) => {
    return useQuery({
        queryKey: ["getReferences", codingWipKey],
        queryFn: () => getAttributesForReferences({ wip: codingWipKey, pids: activeProductKeys }),
        enabled: false,
    });
};
